import React from "react";
import "./Header.css";

const Header = ({ openAbout, openContacts }) => {
  return (
    <header className="custom-header">
      {/* Left (empty for spacing balance) */}
      <div className="header-left"></div>

      {/* Center */}
      <div className="header-center">
        <span className="header-text">SINCE 2026</span>
      </div>

      {/* Right */}
      <div className="header-right">
        <span
          className="header-text"
          onClick={openAbout}
          style={{ cursor: "pointer" }}
        >
          ABOUT
        </span>
        <span
          className="header-text"
          onClick={openContacts}
          style={{ cursor: "pointer" }}
        >
          FAQs
        </span>
        <MenuIcon />
      </div>
    </header>
  );
};

const MenuIcon = () => (
  <div className="menu-icon">
    <div className="menu-line" />
    <div className="menu-line" />
  </div>
);

export default Header;